import { useHttpClient } from '../../http/index';
import { GetProfileResponse, UpdateProfileSettingsParams } from './types';

const { get, patch } = useHttpClient();

export const useProfileApi = () => {
  const getProfile = async () => {
    const { data } = await get<GetProfileResponse>('/v1/user/profile', {
      timeout: 120_000,
    });
    return data;
  };

  const updateUserSettings = (upgradeSettings: UpdateProfileSettingsParams) => {
    const settings: Record<string, string> = {};

    Object.entries(upgradeSettings || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      settings[key] = String(value);
    });

    return patch<{ status: number }>('/v1/user/update_settings', {
      settings,
    });
  };

  return {
    getProfile,
    updateUserSettings,
  };
};
